import CarouselContainer from './CarouselContainer';

export default CarouselContainer;
